var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modules-settings-vendors-list" }, [
    _c(
      "div",
      { staticClass: "link-btn-group" },
      [
        _c(
          "a",
          {
            staticClass: "all-contractors",
            on: {
              click: function ($event) {
                return _vm.navToPage("all-contractors")
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("view")) +
                " " +
                _vm._s(_vm.$t("settings.user.vendor.all")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("HKLButton", {
          staticClass: "reset-btn",
          attrs: { color: "darkblue", action: "resetFilter" },
          on: { click: _vm.resetFilter },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "total-with-refresh" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.$t("total")) +
            ": " +
            _vm._s(_vm.orderedItems.length) +
            " / " +
            _vm._s(_vm.vendorListResult.length)
        ),
      ]),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa fa-refresh dark flat icon_refresh",
        on: { click: _vm.loadData },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tender-table" }, [
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.itemHeaders, function (header, index) {
              return _c(
                "th",
                {
                  key: index,
                  class: [header.class, header.code],
                  on: {
                    click: function ($event) {
                      return _vm.sortBy(header.code)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t(header.name)) +
                      " " +
                      _vm._s(
                        _vm.sortingObject.orderbyAttr === header.code
                          ? _vm.sortingObject.reverse
                            ? "▼"
                            : "▲"
                          : null
                      ) +
                      "\n          "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", [
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filterObject.name,
                      expression: "filterObject.name",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: { type: "text" },
                  domProps: { value: _vm.filterObject.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.filterObject, "name", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center department",
                    attrs: {
                      value: _vm.filterObject.department,
                      "settings-filter-row": "",
                      options: _vm.departmentHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.filterObject.department = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filterObject.username,
                      expression: "filterObject.username",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: { type: "text" },
                  domProps: { value: _vm.filterObject.username },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.filterObject,
                        "username",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter align-center" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.filterObject.primary,
                      "settings-filter-row": "",
                      options: _vm.isAdminHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.filterObject.primary = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter align-center" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.filterObject.enabled,
                      "settings-filter-row": "",
                      options: _vm.statusHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.filterObject.enabled = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.filterObject.merge,
                      "settings-filter-row": "",
                      options: _vm.mergeHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.filterObject.merge = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2" } }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.orderedItems, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.navToDetail(item.company.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.company.name))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " + _vm._s(item.department) + "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "align-left" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(item.username) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm._f("customYNLabel")(
                          item.primary
                            ? _vm.isAdminFilter.YES
                            : _vm.isAdminFilter.NO
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("customStatusLabel")(
                          item.enabled
                            ? _vm.statusFilter.ACTIVE
                            : _vm.statusFilter.INACTIVE
                        )
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("customYNLabel")(
                          item.company.specialHandled
                            ? _vm.mergeFilter.YES
                            : _vm.mergeFilter.NO
                        )
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formatDate(item.lastLoginAt)) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formatDate(item.invitedAt)) +
                      "\n          "
                  ),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }